module.exports = __webpack_public_path__ + "static/intro-07917fec1805262236bf3565da3e6e7e.webm";